import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StickyNote2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"sticky_note_2"}/>
}
